import { useFeatureFlags } from '../../context/FeatureFlagsContext';
export const useGatewayUrlResolver = (originalUrl, gatewayUrl) => {
    const { getFeatureFlag } = useFeatureFlags();
    const isGatewayUrlEnabled = getFeatureFlag('enableDashboardGatewayUrlsTemp');
    return isGatewayUrlEnabled ? gatewayUrl : originalUrl;
};
